import { Box } from "@mui/material";
import { HeroSection } from "../../../sections/HeroSection";
import { ContactBannerSection } from "../../../sections/ContactBannerSection";
import Service from "../service/Service";
import CaseList from "../case/CaseList";
import Lab from "../lab/Lab";
import About from "../about/About";

// ルートページ。ヘッダーナビのアンカー先となる各セクションをすべて配置する
function Top() {
  return (
    <Box>
      <HeroSection />
      <ContactBannerSection />
      <Service />
      <CaseList />
      <Lab />
      <About />
    </Box>
  );
}

export default Top;
